import React from "react";
import styled from "styled-components";
import Icons from "../../../Icons";
import Badge from "../../../Badge";
import ProjectTitle from "../ProjectTitle";
import ProjectSection from "../ProjectSection";
import ProjectSectionSkills from "../ProjectSectionSkills";
import ProjectDescription from "../ProjectDescription";
import ProjectHeroImage from "../ProjectHeroImage";
import Src1 from "../../../../img/myob-invoicing-insights.jpg";
import Src2 from "../../../../img/myob-invoicing-quote.jpg";

const InvoicingProjectSection = styled(ProjectSection)`
  background: #703993;
`;

function MYOBInvoices() {
  return (
    <InvoicingProjectSection>
      <ProjectTitle title="MYOB Invoicing" tag="2018" />
      <ProjectSectionSkills>
        <Badge small title="UI Design">
          <Icons type="rgba-small" />
        </Badge>
        <Badge small title="UX Design">
          <Icons type="ux-small" />
        </Badge>
      </ProjectSectionSkills>
      <ProjectDescription>
        Research has shown that quotes would be a useful feature for MYOB Invoicing to introduce. With the task of
        adding quotes to the current mobile application, there was an opportunity to review the workflow across Invoices
        also, so the work completed in quotes would need to be a holistic vision for the future experience of the MYOB
        Invoicing application.
      </ProjectDescription>

      <ProjectHeroImage srcMobile1={Src1} srcMobile2={Src2} mobile lazy />
    </InvoicingProjectSection>
  );
}

export default MYOBInvoices;
